export const buttonsTranslationHE = {
  buttons: {
    "save": "שמור",
    "cancel": "ביטול",
    "new": "חדש",
    "close": "סגור",
    "exit": "יציאה",
    "back": "חזור",
  }
}